/**
 * Define a stage of onboarding for user based on 1st subscription date
 * -1 - if user is not subscribed
 *  0 - if user is subscribed less than 21 days
 * 21 - if user is subscribed more than 21 days
 *
 * for more details check SB-971
 */
const getDaysFromFirstSubscription = (daysFromFirstSubscription: number): -1 | 0 | 21 => {
  if (typeof daysFromFirstSubscription !== 'number') {
    return -1
  }

  return daysFromFirstSubscription > 20 ? 21 : 0
}


export default getDaysFromFirstSubscription
